module.exports = __webpack_public_path__ + "static/media/c2_mobile.94bca73f.png";